var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24487 14.7815L10.238 10.8914L13.6522 13.5733L16.5813 9.79297",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9954,
    cy: 4.20027,
    r: 1.9222,
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9245 3.12024H7.65679C4.64535 3.12024 2.77808 5.25296 2.77808 8.2644V16.3468C2.77808 19.3582 4.60874 21.4818 7.65679 21.4818H16.2609C19.2724 21.4818 21.1396 19.3582 21.1396 16.3468V9.30788",
    stroke: "#53545C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeads);
export default __webpack_public_path__ + "static/media/leads.ada0007aae117705f769d03220c91508.svg";
export { ForwardRef as ReactComponent };